import { useCallback, useState } from 'react';
import { storeState } from '~/store';
import { isRenewalHttpError } from '../renewalErrors';

/**
 * Salvamento de um card da revisão: erro do servidor fica visível no card (e a edição continua aberta);
 * falha de rede vira toast. Devolve `true` quando salvou.
 */
export function useRenewalCardSave(serverMessage: string) {
  const [saving, setSaving] = useState(false);
  const [serverError, setServerError] = useState<string | null>(null);

  const run = useCallback(
    async (save: () => Promise<void>) => {
      setSaving(true);
      setServerError(null);
      try {
        await save();
        return true;
      } catch (error: unknown) {
        if (isRenewalHttpError(error)) {
          setServerError(serverMessage);
        } else {
          storeState.addToast({
            title: 'Sem conexão',
            message: 'Não foi possível salvar. Verifique sua conexão e tente novamente.',
            type: 'error'
          });
        }
        return false;
      } finally {
        setSaving(false);
      }
    },
    [serverMessage]
  );

  return { saving, serverError, clearServerError: () => setServerError(null), run };
}
